// ===== CONFIGURATION DUPSCAN =====

export const APP_CONFIG = {
  name: "DupScan",
  version: __APP_VERSION__ || "1.0.0",
  description: "Détecteur de doublons pour mesures OTDR",
};

// ===== FICHIER EXCEL =====
export const EXCEL_CONFIG = {
  maxFileSize: 5 * 1024 * 1024, // 5 Mo
  acceptedTypes: [".xlsx"],
  // Sheet unique à parser
  sheet: "Atténuations (dB)",
};

// ===== COLONNES OBLIGATOIRES =====
export const REQUIRED_COLUMNS = {
  ID_CABLE: "ID Câble",
  NUM_FIBRE: "N° Fibre",
  COULEUR: "Couleur",
  LAMBDA: "Lambda",
  // Colonnes des moyennes (utilisées pour la comparaison)
  MOYENNE_CONNECTEURS: "Moyenne connecteurs",
  MOYENNE_EPISSURES: "Moyenne épissures",
  PERTE_TOTALE: "Perte totale",
};

// ===== LONGUEURS D'ONDE =====
export const WAVELENGTHS = {
  LAMBDA_1310: "1310",
  LAMBDA_1550: "1550",
  REQUIRED_COUNT: 2, // Chaque fibre doit avoir exactement 2 longueurs d'onde
};

// ===== DÉTECTION DE DOUBLONS =====
// Seuils pour la comparaison des 3 moyennes
// Logique OU : au moins 1 des 3 critères doit être respecté
export const DETECTION_CONFIG = {
  seuilMoyenneConnecteurs: 0.02, // Tolérance pour Moyenne connecteurs (dB)
  seuilMoyenneEpissures: 0.05, // Tolérance pour Moyenne épissures (dB)
  seuilPerteTotale: 0.1, // Tolérance pour Perte totale (dB)
};

// ===== MESSAGES =====
export const MESSAGES = {
  // Upload
  UPLOAD_SUCCESS: "Fichier chargé avec succès",
  UPLOAD_ERROR_SIZE: "Fichier trop volumineux (maximum 5 Mo)",
  UPLOAD_ERROR_TYPE: "Type de fichier non autorisé (uniquement .xlsx)",
  UPLOAD_ERROR_READ: "Erreur lors de la lecture du fichier",

  // Validation
  VALIDATION_ERROR_SHEET: (sheetName) => `Feuille "${sheetName}" introuvable`,
  VALIDATION_ERROR_COLUMNS: "Colonnes obligatoires manquantes",
  VALIDATION_ERROR_WAVELENGTH: "Fibres avec longueurs d'onde manquantes détectées",

  // Résultats
  ANALYSIS_COMPLETE: "Analyse terminée",
  NO_DUPLICATES: "Aucun doublon détecté",
  DUPLICATES_FOUND: "paire(s) suspecte(s) trouvée(s)",
};

// ===== TOASTER =====
export const TOASTER_CONFIG = {
  duration: 5000, // 5 secondes
  maxHistory: 100,
  types: {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
  },
};

// ===== MODAL =====
export const MODAL_CONFIG = {
  closeOnBackdrop: false, // Les erreurs bloquantes ne se ferment pas au clic extérieur
  closeOnEscape: false,
};
